<template>
  <van-popup v-model:show="visible" position="center" round :style="{ width: '92%', maxHeight: '90vh', top: '50%' }"
    class="pay-info-popup" :overlay-style="{ background: 'rgba(0,0,0,0.5)' }">
    <div class="pay-info-view">
      <div class="pay-info-header">
        <div class="pay-info-title">{{ order?.paytypeName || '充值' }}</div>
      </div>

      <div class="pay-info-body">
        <div class="pay-amount-display">
          <div class="pay-amount-label">充值金额</div>
          <div class="pay-amount-value">
            <span class="currency">¥</span>
            <span class="num" style="font-size: 21px;">{{ order?.amount }}</span>
          </div>
          <div style="display: flex; align-items: center; justify-content: center;">
            <div class="pay-amount-label" style="font-size:23px"><span style="font-weight: bold;">折合：</span><span style="color: #ff4d4f;">{{ order?.uBlance }}
                USDT</span> </div>
            <van-icon name="description-o" style="margin-bottom: 8px;margin-left: 16px;" class="copy-icon1"
              @click="copyText(order?.uBlance)" />
          </div>
          <div class="pay-status-tag">待支付</div>
        </div>

        <div class="info-cell-group">
          <div class="info-cell">
            <span class="cell-label">订单号</span>
            <div class="cell-value">
              {{ order?.trano }}
              <van-icon name="description-o" class="copy-icon" @click="copyText(order?.trano)" />
            </div>
          </div>
          <div class="info-cell" v-if="order?.fuyanma">
            <span class="cell-label">附言码</span>
            <div class="cell-value highlight-red">
              {{ order?.fuyanma }}
              <van-icon name="description-o" class="copy-icon" @click="copyText(order?.fuyanma)" />
            </div>
          </div>
        </div>

        <div class="pay-content-area">
          <div style="text-align: center;padding-bottom: 6rpx;" class="highlight-red">请往下拉上传转账截图↓</div>
          <div class="chain-selector" v-if="order?.paytype === 'USDT'">
            <div class="chain-option" :class="{ active: selectedChain === 'TRC20' }" @click="selectedChain = 'TRC20'">
              TRC20
            </div>
            <!-- <div 
              class="chain-option" 
              :class="{ active: selectedChain === 'ERC20' }"
              @click="selectedChain = 'ERC20'"
            >
              ERC20
            </div> -->
          </div>

          <div class="pay-details-box" v-if="currentPayAddress">
            <div class="address-display">
              <div class="address-label">
                {{ order?.paytype === 'USDT' ? '充值地址' : '收款账号' }}
              </div>
              <div class="address-content">
                <div class="address-text">{{ currentPayAddress }}</div>
              </div>
              <div class="address-actions">
                <div class="action-btn" @click="copyAddress">
                  <van-icon name="description" /> 复制
                </div>
              </div>
            </div>
            <div class="payee-name" v-if="order?.accountName">
              收款人：{{ order.accountName }}
            </div>
          </div>

          <div class="qr-container" v-if="currentPayQrCode">
            <div class="qr-wrapper">
              <img :src="currentPayQrCode" class="qr-image" />
            </div>
            <div class="qr-text">扫码支付</div>
          </div>

          <div class="pay-details-box" v-if="order?.paytype === 'linepay' && order.bankInfo">
            <div class="bank-card">
              <div class="bank-row">
                <span class="bank-label">银行</span>
                <span class="bank-val">{{ order.bankInfo.bankName }}</span>
                <span class="copy-btn-text" @click="copyText(order.bankInfo.bankName)">复制</span>
              </div>
              <div class="bank-row" v-if="order.bankInfo.bankBranch">
                <span class="bank-label">分行</span>
                <span class="bank-val">{{ order.bankInfo.bankBranch }}</span>
                <span class="copy-btn-text" @click="copyText(order.bankInfo.bankBranch)">复制</span>
              </div>
              <div class="bank-row">
                <span class="bank-label">姓名</span>
                <span class="bank-val">{{ order.bankInfo.accountName }}</span>
                <span class="copy-btn-text" @click="copyText(order.bankInfo.accountName)">复制</span>
              </div>
              <div class="bank-row">
                <span class="bank-label">卡号</span>
                <span class="bank-val bank-code">{{ order.bankInfo.bankCode }}</span>
                <span class="copy-btn-text" @click="copyText(order.bankInfo.bankCode)">复制</span>
              </div>
            </div>
          </div>



          <div class="no-address-tip" v-else-if="order?.paytype === 'USDT' && !currentPayAddress">
            <van-icon name="warning-o" size="40" color="#ff976a" />
            <div class="tip-text">收款地址暂未配置</div>
            <div class="tip-sub">请联系客服获取充值地址</div>
          </div>
        </div>


        <div class="form-item" style="padding: 6px 20px;background-color: #fff;margin: 10px 20px;border-radius: 8px;">
          <div class="form-label">上传支付凭证</div>
          <div class="upload-area">
            <div class="upload-box" v-for="(img, idx) in images" :key="idx">
              <img :src="img" class="preview-img" />
              <van-icon name="cross" class="remove-btn" @click="removeImage(idx)" />
            </div>
            <div class="upload-box add" v-if="images.length < 1" @click="triggerUpload">
              <van-icon name="plus" />
            </div>
            <input type="file" ref="feedbackImageInput" accept="image/*" style="display: none"
              @change="handleFeedbackImage" />
          </div>
        </div>

        <div class="pay-footer-section">
          <div class="warning-tips">
            <van-icon name="info-o" />
            <span v-if="order?.paytype === 'USDT'">请务必使用 {{ selectedChain }} 网络转账，否则无法到账</span>
            <span v-else>请确认收款信息一致后再转账</span>
          </div>

          <div class="confirm-check-row">
            <van-checkbox v-model="payConfirmed" checked-color="#04BE02" icon-size="16px">
              我已完成转账
            </van-checkbox>
          </div>

          <div class="submit-pay-btn" :class="{ disabled: !payConfirmed }" @click="confirmPayment">
            确认提交
          </div>
        </div>
      </div>
    </div>

    <div class="close-circle-outer" @click="visible = false">
      <van-icon name="cross" size="18" />
    </div>
  </van-popup>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { showToast, showLoadingToast, closeToast } from 'vant'
import { rechargeApi } from '@/api/recharge'
import { uploadFile } from '@/api/im'

const props = defineProps({
  show: { type: Boolean, default: false },
  order: { type: Object, default: null },
  usdtConfig: { type: Object, default: () => ({ trc20Address: '', erc20Address: '', rate: 7.2 }) }
})

const emit = defineEmits(['update:show', 'confirmed'])

const visible = computed({
  get: () => props.show,
  set: (val) => emit('update:show', val)
})

const selectedChain = ref('TRC20')
const payConfirmed = ref(false)
// 认证图片
const images = ref([])
const images_url = ref()
const feedbackImageInput = ref(null)
const removeImage = (idx) => {
  images.value.splice(idx, 1)
}
const triggerUpload = () => {
  feedbackImageInput.value?.click()
}
const handleFeedbackImage = async (e) => {
  const file = e.target.files[0]
  if (!file) return

  if (!file.type.startsWith('image/')) {
    showToast('请选择图片文件')
    return
  }

  if (file.size > 2 * 1024 * 1024) {
    showToast('图片大小不能超过2MB')
    return
  }
  const formData = new FormData()
  formData.append('file', file)
  const res = await uploadFile(formData)
  console.log('上传图片响应：', res)
  const url = res.data.data?.url
  if (url) {
    images_url.value = url
  }
  const link_url = res.data.data?.link_url
  if (link_url) {
    images.value.push(link_url)
  }
  e.target.value = ''
}

const currentPayAddress = computed(() => {
  if (!props.order) return ''
  const type = props.order.paytype

  if (type === 'USDT') {
    if (selectedChain.value === 'TRC20') {
      return props.usdtConfig.trc20Address || props.order.address || ''
    }
    return props.usdtConfig.erc20Address || ''
  }

  if (type === 'alipay' || type === 'weixin') {
    return props.order.account || ''
  }

  return ''
})

const currentPayQrCode = computed(() => {
  if (!props.order) return ''
  const type = props.order.paytype

  if (type === 'USDT') {
    const addr = currentPayAddress.value
    if (!addr) return ''
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${addr}&color=000000&bgcolor=ffffff`
  }

  if (type === 'alipay' || type === 'weixin') {
    return props.order.qrcode || ''
  }
  return ''
})

const copyText = async (text) => {
  if (!text) return
  try {
    await navigator.clipboard.writeText(text)
    showToast('已复制')
  } catch (e) {
    showToast('复制失败')
  }
}

const copyAddress = async () => {
  await copyText(currentPayAddress.value)
  showToast('地址已复制')
}

const confirmPayment = async () => {
  if (!payConfirmed.value) {
    showToast('请先确认已完成转账')
    return
  }

  if (!props.order?.trano) {
    showToast('订单信息不存在')
    return
  }
  if (!images_url.value) {
    showToast('请上传支付凭证')
    return
  }
  try {
    showLoadingToast({ message: '提交中...', forbidClick: true, duration: 0 })
    const paramt = {
      trano: props.order.trano,
      img: images_url.value
    }

    const res = await rechargeApi.confirm(paramt)
    closeToast()

    if (res.code === 0) {
      showToast({ type: 'success', message: '确认成功，请等待审核' })
      visible.value = false
      emit('confirmed')
    } else {
      showToast(res.message || '确认失败')
    }
  } catch (e) {
    closeToast()
    showToast('网络错误，请重试')
  }
}
watch(visible, (val) => {
  if (!val) {
    payConfirmed.value = false
  }
  images.value = []
  images_url.value = ''
})

</script>

<style scoped>
.form-item {
  margin-bottom: 20px;
}

.form-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.form-label .required {
  color: #ff4d4f;
  margin-left: 2px;
}

.upload-area {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.upload-box {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.upload-box.add {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ccc;
  background: #f5f5f5;
}

.upload-box.add .van-icon {
  font-size: 24px;
  color: #999;
}

.upload-box .preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-box .remove-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}

.pay-info-popup {
  overflow: visible !important;
  background: transparent !important;
  max-height: calc(100dvh - 16px) !important;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
}

.pay-info-view {
  background: #f9f9f9;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  max-height: min(80vh, calc(100dvh - 106px - env(safe-area-inset-bottom)));
  overflow: hidden;
}

.pay-info-header {
  background: #fff;
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.pay-info-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.pay-info-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  max-height: none;
}

.pay-amount-display {
  background: #fff;
  padding: 25px 0 20px;
  text-align: center;
}

.pay-amount-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}

.pay-amount-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  color: #333;
  font-weight: 600;
}

.pay-amount-value .currency {
  font-size: 20px;
  margin-right: 4px;
}

.pay-amount-value .num {
  font-size: 32px;
  font-family: DIN Alternate, sans-serif;
}

.pay-status-tag {
  display: inline-block;
  margin-top: 8px;
  background: rgba(255, 149, 0, 0.1);
  color: #ff9500;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
}

.info-cell-group {
  background: #fff;
  padding: 0 15px 15px;
  margin-bottom: 10px;
}

.info-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid #f5f5f5;
  font-size: 14px;
}

.cell-label {
  color: #999;
}

.cell-value {
  color: #333;
  display: flex;
  align-items: center;
  gap: 5px;
}

.highlight-red {
  color: #ff4d4f;
  font-weight: 600;
}

.copy-icon {
  color: #26A17B;
  font-size: 14px;
  cursor: pointer;
}

.copy-icon1 {
  color: #26A17B;
  font-size: 18px;
  cursor: pointer;
}

.pay-content-area {
  background: #fff;
  margin: 0 15px;
  border-radius: 12px;
  padding: 20px 15px;
}

.chain-selector {
  display: flex;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.chain-option {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  color: #666;
  border-radius: 6px;
  transition: all 0.3s;
  cursor: pointer;
}

.chain-option.active {
  background: #fff;
  color: #04BE02;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.qr-container {
  text-align: center;
  margin-bottom: 20px;
}

.qr-wrapper {
  width: 160px;
  height: 160px;
  margin: 0 auto 10px;
  padding: 8px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.qr-image {
  width: 100%;
  height: 100%;
}

.qr-text {
  font-size: 12px;
  color: #999;
}

.address-display {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}

.address-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.address-text {
  font-size: 13px;
  color: #333;
  word-break: break-all;
  line-height: 1.4;
  font-weight: 500;
  margin-bottom: 12px;
}

.address-actions {
  display: flex;
  justify-content: center;
}

.action-btn {
  background: #26A17B;
  color: #fff;
  font-size: 12px;
  padding: 6px 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.payee-name {
  margin-top: 10px;
  text-align: center;
  font-size: 13px;
  color: #666;
}

.bank-card {
  background: linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%);
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 15px;
}

.bank-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.bank-row:last-child {
  margin-bottom: 0;
}

.bank-label {
  color: #999;
  width: 50px;
}

.bank-val {
  color: #333;
  font-weight: 500;
  flex: 1;
}

.bank-code {
  font-family: monospace;
  letter-spacing: 1px;
}

.copy-btn-text {
  color: #26A17B;
  font-size: 12px;
  padding: 2px 8px;
  border: 1px solid #26A17B;
  border-radius: 4px;
  cursor: pointer;
}

.no-address-tip {
  background: #fff;
  border-radius: 8px;
  padding: 30px 15px;
  text-align: center;
}

.no-address-tip .tip-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  margin-top: 12px;
}

.no-address-tip .tip-sub {
  font-size: 13px;
  color: #999;
  margin-top: 6px;
}

.pay-footer-section {
  padding: 20px 15px;
}

.warning-tips {
  background: #fffbe8;
  color: #ed6a0c;
  font-size: 12px;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.4;
}

.confirm-check-row {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.submit-pay-btn {
  height: 44px;
  background: #26A17B;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(38, 161, 123, 0.3);
}

.submit-pay-btn.disabled {
  background: #ccc;
  box-shadow: none;
  cursor: not-allowed;
}

.close-circle-outer {
  margin: 10px auto 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  flex-shrink: 0;
}
</style>
